import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Container from '@material-ui/core/Container';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import DateFnsUtils from '@date-io/date-fns';
import jwt from 'jsonwebtoken'
import onLocalStorage from './localStorage'
import { useLocation, useHistory } from "react-router-dom";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';

import ProvinsiData from './ProvinsiData'
import KabupatenData from './KabupatenData'

const useStyles = makeStyles((theme) => ({
  input: {
    marginTop: '3%'
  },
  root: {
    height: '110vh',
    marginTop: '2%'
  },
  large: {
    width: theme.spacing(10),
    height: theme.spacing(10),
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  body: {
    marginTop: '3%'
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const Gender = ['Laki - Laki', 'Perempuan']
const Marital = ['Belum Kawin', 'Kawin', 'Cerai']
const Religion = ['Islam', 'Katolik', 'Protestan', 'Hindu', 'Budha', 'Kepercayaan']

export default function BiodataRegister() {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [gender, setGender] = useState('')
  const [marital, setMarital] = useState('')
  const [religion, setReligion] = useState('')
  const [province, setProvince] = useState('')
  const [districts, setDistricts] = useState('')
  const [fullname, setFullname] = useState('')
  const [email, setEmail] = useState('')
  const [noWA, setNoWA] = useState('')
  const [zoom, setZoom] = useState('')
  const [nik, setNik] = useState('')
  const [address, setAddress] = useState('')
  const [kecamatan, setKecamatan] = useState('')
  const [kelurahan, setKelurahan] = useState('')
  const [postalCode, setPostalCode] = useState('')
  const [birthPlace, setBirthPlace] = useState('')
  const [participantId, setParticipantId] = useState('')
  const [viewDistricts, setViewDistricts] = useState([])

  const handleChangeGender = (event) => {
    setGender(event.target.value);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleChangeMarital = (event) => {
    setMarital(event.target.value)
  }

  const handleChangeReligion = (event) => {
    setReligion(event.target.value)
  }

  const handleChangeProvince = async (event) => {
    let provinsi = ProvinsiData
    let kabupaten = KabupatenData

    let provinsiFilter = provinsi.filter(function (word) {
      return event.target.value.name === word.name;
    })

    var kab_filter = kabupaten.filter(function (word) {
      return provinsiFilter[0].code === word.provinsi_id;
    });

    setViewDistricts(kab_filter)
    setProvince(event.target.value)
  }

  const handleChangeDistricts = (event) => {
    setDistricts(event.target.value)
  }

  useEffect(async () => {
    let token = location.pathname.split('/')[3]
    let decoded = jwt.verify(token, process.env.REACT_APP_SECRET);
    setParticipantId(decoded.id)
    setFullname(decoded.name)
    setEmail(decoded.email)
    setNoWA(decoded.no_wa)
    setZoom(decoded.zoom_user)

    if (localStorage.getItem("biodata") !== null) {
      let biodataLocal = JSON.parse(localStorage.getItem("biodata"))
      setSelectedDate(biodataLocal.selectedDateBorn)
      setGender(biodataLocal.gender)
      setMarital(biodataLocal.marital)
      setReligion(biodataLocal.religion)
      setProvince(biodataLocal.province)
      setDistricts(biodataLocal.districts)
      setFullname(biodataLocal.fullname)
      setEmail(biodataLocal.email)
      setNoWA(biodataLocal.noWA)
      setZoom(biodataLocal.zoom)
      setNik(biodataLocal.nik)
      setAddress(biodataLocal.address)
      setKecamatan(biodataLocal.kecamatan)
      setKelurahan(biodataLocal.kelurahan)
      setPostalCode(biodataLocal.postalCode)
      setBirthPlace(biodataLocal.birthPlace)
    }
  }, [])

  return (
    <Container component="main" maxWidth="md" className={classes.root}>
      <div className={classes.header}>
        <Avatar alt="Jababeka Logo" src="/logo512.png" variant="square" className={classes.large} />
        <Typography component="h1" variant="h5">
          KAWASAN INDUSTRI JABABEKA
        </Typography>
        <Typography variant="subtitle1">
          PROUDLY PRESENT
        </Typography>
        <Typography component="h1" variant="h6" gutterBottom>
          VIRTUAL JOB FAIR 2021
        </Typography>
      </div>
      <CssBaseline />
      <Grid container spacing={3} className={classes.body}>
        <Grid item xs={12} sm={6}>
          <TextField
            variant="outlined"
            required
            fullWidth
            id="fullname"
            label="Nama Lengkap"
            name="fullname"
            disabled
            className={classes.input}
            value={fullname}
            size="small"
          />

          <TextField
            variant="outlined"
            required
            fullWidth
            id="email"
            label="Email"
            name="email"
            autoComplete="email"
            disabled
            className={classes.input}
            value={email}
            size="small"
          />

          <TextField
            variant="outlined"
            required
            fullWidth
            id="phonenumber"
            label="No. Whatsapp / WA"
            name="phonenumber"
            autoComplete="phonenumber"
            disabled
            className={classes.input}
            value={noWA}
            size="small"
          />

          <TextField
            variant="outlined"
            required
            fullWidth
            id="zoom"
            label="Username Zoom"
            name="zoom"
            autoComplete="zoom"
            disabled
            className={classes.input}
            value={zoom}
            size="small"
          />

          <TextField
            variant="outlined"
            required
            fullWidth
            id="nik"
            label="NIK"
            name="nik"
            autoComplete="nik"
            className={classes.input}
            onChange={e => setNik(e.target.value)}
            value={nik}
            size="small"
          />

          <FormControl variant="outlined" fullWidth className={classes.input} size="small">
            <InputLabel id="participan_type" required>Jenis Kelamin</InputLabel>
            <Select
              labelId="gender"
              id="gender"
              value={gender}
              onChange={handleChangeGender}
              label="Jenis Kelamin"
            >
              {
                Gender.map((value, index) => {
                  return (
                    <MenuItem key={index} value={value}>{value}</MenuItem>
                  )
                })
              }
            </Select>
          </FormControl>

          <TextField
            variant="outlined"
            required
            fullWidth
            id="birth_place"
            label="Tempat Lahir"
            name="birth_place"
            autoComplete="birth_place"
            className={classes.input}
            onChange={e => setBirthPlace(e.target.value)}
            value={birthPlace}
            size="small"
          />

          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              className={classes.input}
              disableToolbar
              fullWidth
              required
              variant="inline"
              format="MM/dd/yyyy"
              margin="normal"
              id="date-picker-inline"
              label="Tanggal Lahir"
              value={selectedDate}
              onChange={handleDateChange}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              size="small"
            />
          </MuiPickersUtilsProvider>

          <FormControl variant="outlined" fullWidth className={classes.input} size="small">
            <InputLabel id="marital" required>Status Pernikahan</InputLabel>
            <Select
              labelId="marital"
              id="marital"
              value={marital}
              onChange={handleChangeMarital}
              label="Status Pernikahan"
            >
              {
                Marital.map((value, index) => {
                  return (
                    <MenuItem key={index} value={value}>{value}</MenuItem>
                  )
                })
              }
            </Select>
          </FormControl>

          <FormControl variant="outlined" fullWidth className={classes.input} size="small">
            <InputLabel id="participan_type" required>Agama</InputLabel>
            <Select
              labelId="religion"
              id="religion"
              value={religion}
              onChange={handleChangeReligion}
              label="Religion"
            >
              {
                Religion.map((value, index) => {
                  return (
                    <MenuItem key={index} value={value}>{value}</MenuItem>
                  )
                })
              }
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id="outlined-multiline-static"
            label="Alamat"
            multiline
            fullWidth
            rows={4}
            variant="outlined"
            className={classes.input}
            onChange={e => setAddress(e.target.value)}
            value={address}
            size="small"
          />

          <FormControl variant="outlined" fullWidth className={classes.input} size="small">
            <InputLabel id="province" required>Provinsi</InputLabel>
            <Select
              labelId="province"
              id="province"
              value={province}
              onChange={handleChangeProvince}
              label="Provinsi"
            >
              {
                ProvinsiData.map((value, index) => {
                  return (
                    <MenuItem key={index} value={value}>{value.name}</MenuItem>
                  )
                })
              }
            </Select>
          </FormControl>

          <FormControl variant="outlined" fullWidth className={classes.input} size="small">
            <InputLabel id="districts" required>Kabupaten</InputLabel>
            <Select
              labelId="districts"
              id="districts"
              value={districts}
              onChange={handleChangeDistricts}
              label="districts"
            >
              {
                viewDistricts.map((value, index) => {
                  return (
                    <MenuItem key={index} value={value}>{value.name}</MenuItem>
                  )
                })
              }
            </Select>
          </FormControl>

          <TextField
            variant="outlined"
            required
            fullWidth
            id="kecamatan"
            label="Kecamatan"
            name="kecamatan"
            autoComplete="kecamatan"
            className={classes.input}
            onChange={e => setKecamatan(e.target.value)}
            value={kecamatan}
            size="small"
          />

          <TextField
            variant="outlined"
            required
            fullWidth
            id="kelurahan"
            label="Kelurahan"
            name="kelurahan"
            autoComplete="kelurahan"
            className={classes.input}
            onChange={e => setKelurahan(e.target.value)}
            value={kelurahan}
            size="small"
          />

          <TextField
            variant="outlined"
            required
            fullWidth
            id="postal_code"
            label="Kode Pos"
            name="postal_code"
            autoComplete="postal_code"
            className={classes.input}
            onChange={e => setPostalCode(e.target.value)}
            value={postalCode}
            size="small"
          />

        </Grid>
      </Grid>
      <Button
        type="button"
        fullWidth
        variant="contained"
        color="primary"
        size="large"
        className={classes.submit}
        onClick={() => onLocalStorage(selectedDate, gender, marital, religion, province, districts, fullname, email, noWA, zoom, nik, address, kecamatan, kelurahan, postalCode, history, participantId, birthPlace)}
      >
        LANJUTKAN
      </Button>
    </Container>
  );
}